// Popup Product Images slider
$(function() {
  
  var propsval;
  
  $('#proddrawerPetName').change(function () {
    propsval = $(this).val();
    $("#PetName").val(propsval);
  });
  
  $('#proddrawerPetPhoneNumber').change(function () {
    propsval = $(this).val();
    $("#PetPhoneNumber").val(propsval);
  });
  
  $('#PetName').change(function () {
    propsval = $(this).val();
    $("#proddrawerPetName").val(propsval);
  });
  
  $('#PetPhoneNumber').change(function () {
    propsval = $(this).val();
    $("#proddrawerPetPhoneNumber").val(propsval);
  });
   
  $('.product-drawer-photos__item--main').slick({
    accessibility: false,
    arrows: true,
    dots: false,
    infinite: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon icon-arrow-right" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve"><g><path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"/></g></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon icon-arrow-right" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;" xml:space="preserve"><g><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/></g></svg></button>',
  });

  $('.product-drawer-product-single__thumbnails').slick({
    accessibility: false,
    arrows: true,
    dots: false,
    infinite: false,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 3,  
    prevArrow: '<button type="button" class="slick-prev"><span class=""><svg class="icon icon-arrow-right" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;" xml:space="preserve"><g><path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"/></g></svg></span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class=""><svg class="icon icon-arrow-right" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;" xml:space="preserve"><g><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/></g></svg></span></button>',
  });

  $(".product-drawer-product-single__thumbnail").click(function(evt){
    evt.preventDefault();
    var prod_thumbId;
    prod_thumbId = $(this).parents(".product-single__thumbnail-item").attr("data-image-id");
  	changeMasterImg(prod_thumbId);
  });

});

function changeMasterImg(imgId){
console.log("changeMasterImg");
  var prod_thumbnailToShow;
  var prod_thumbnailsToHide;
  var prod_thumbnailToShow1;
  var prod_thumbnailsToHide1;
  var prod_currentActiveSlideIndex;
  var prod_newActiveSlideIndex;

  prod_thumbnailToShow = $(".product-cart-drawer__content .product-single__photo-wrapper[data-image-id='"+imgId+"']");    
  prod_thumbnailsToHide = $(".product-cart-drawer__content .product-single__photo-wrapper:not([data-image-id='"+imgId+"'])");    

  prod_thumbnailToShow1 = $(".product-cart-drawer__content .product-single__thumbnail-item[data-image-id='"+imgId+"']");    
  prod_thumbnailsToHide1 = $(".product-cart-drawer__content .product-single__thumbnail-item:not([data-image-id='"+imgId+"'])");    

  prod_thumbnailsToHide.removeClass('is-active');
  prod_thumbnailToShow.addClass('is-active');

  prod_thumbnailsToHide1.removeClass('is-active');
  prod_thumbnailToShow1.addClass('is-active');

  if ($(".product-drawer-photos__item--main").hasClass('slick-initialized')) {
    prod_currentActiveSlideIndex = $(".product-drawer-photos__item--main").slick('slickCurrentSlide');
    prod_newActiveSlideIndex = parseInt(prod_thumbnailToShow.attr('data-slick-index'));
    //console.log(prod_currentActiveSlideIndex + " :: "+prod_newActiveSlideIndex)
    if (prod_currentActiveSlideIndex !== prod_newActiveSlideIndex) {
      //console.log("prod_newActiveSlideIndex");
      $(".product-drawer-photos__item--main").slick('slickGoTo', prod_newActiveSlideIndex, false);
    }
  }
  
   $(".mobprod-drawer [data-option-index='0'] .swatch-element[data-vimgid='"+imgId+"']").find("input").trigger("click");  

}
